import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="bg-white dark:bg-background-dark border-t border-[#e7f3ee] dark:border-white/10">
            <div className="max-w-[1100px] mx-auto px-6 py-14">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 text-center sm:text-left">

                    {/* Brand */}
                    <div className="flex flex-col gap-3 items-center sm:items-start sm:col-span-2 md:col-span-1">
                        <Link to="/" className="flex items-center gap-2">
                            <img
                                src={process.env.PUBLIC_URL + "/Logo3.svg"}
                                alt="Tutor Match AE"
                                className="w-10 h-10 object-contain"
                            />
                            <span className="font-bold text-[#0d1b15] dark:text-white text-base">
                                Tutor Match AE
                            </span>
                        </Link>
                        <p className="text-sm text-[#6b8f80] dark:text-white/60 leading-relaxed max-w-[220px]">
                            Connecting students with trusted tutors across the UAE.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="flex flex-col gap-3 items-center sm:items-start">
                        <h3 className="font-semibold text-[#0d1b15] dark:text-white text-sm uppercase tracking-wide">
                            Quick Links
                        </h3>
                        <Link className="text-sm text-[#4c9a78] hover:text-primary transition-colors" to="/about">
                            About
                        </Link>
                        <Link className="text-sm text-[#4c9a78] hover:text-primary transition-colors" to="/privacy">
                            Privacy
                        </Link>
                        <Link className="text-sm text-[#4c9a78] hover:text-primary transition-colors" to="/terms">
                            Terms
                        </Link>
                        <Link className="text-sm text-[#4c9a78] hover:text-primary transition-colors" to="/contact">
                            Contact
                        </Link>
                    </div>

                    {/* Contact */}
                    <div className="flex flex-col gap-3 items-center sm:items-start">
                        <h3 className="font-semibold text-[#0d1b15] dark:text-white text-sm uppercase tracking-wide">
                            Contact
                        </h3>

                        <a
                            href="tel:+971502890291"
                            className="flex items-center gap-2 text-sm text-[#4c9a78] hover:text-primary transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="size-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                            </svg>
                            +971 50 289 0291
                        </a>

                        <a
                            href="mailto:support@tutormatchae.com"
                            className="flex items-center gap-2 text-sm text-[#4c9a78] hover:text-primary transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="size-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 6l-10 7L2 6" />
                                <path d="M2 6h20v12H2z" />
                            </svg>
                            support@tutormatchae.com
                        </a>

                        <div className="flex items-start gap-2 text-sm text-[#4c9a78] text-center sm:text-left">
                            <svg xmlns="http://www.w3.org/2000/svg" className="size-4 mt-0.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            <span>
                                Tutor Match FZ-LLC
                                <br />
                                FDBC4045
                                <br />
                                Compass Building
                                <br />
                                Al Shohada Road
                                <br />
                                Al Hamra Industrial Zone-FZ
                                <br />
                                Ras Al Khaimah
                                <br />
                                United Arab Emirates
                            </span>
                        </div>
                    </div>

                    {/* Socials */}
                    <div className="flex flex-col gap-3 items-center sm:items-start">
                        <h3 className="font-semibold text-[#0d1b15] dark:text-white text-sm uppercase tracking-wide">
                            Follow Us
                        </h3>
                        <div className="flex gap-3">
                            {/* <a href="#" aria-label="Facebook" className="text-[#4c9a78] hover:text-primary transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M22 12a10 10 0 1 0-11.5 9.87v-6.98H7.9V12h2.6V9.8c0-2.57 1.53-4 3.87-4 1.12 0 2.3.2 2.3.2v2.5h-1.3c-1.28 0-1.68.8-1.68 1.62V12h2.86l-.46 2.89h-2.4v6.98A10 10 0 0 0 22 12z" />
                                </svg>
                            </a> */}
                            <a href="https://www.instagram.com/tutormatch_ae?igsh=MXM4bm5sYmE1ODBrbw%3D%3D&utm_source=qr" target="_blank" aria-label="Instagram" className="text-[#4c9a78] hover:text-primary transition-colors" rel='noreferrer'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="2" width="20" height="20" rx="5" />
                                    <circle cx="12" cy="12" r="4" />
                                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                                </svg>
                            </a>
                            {/* <a href="#" aria-label="LinkedIn" className="text-[#4c9a78] hover:text-primary transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.59 0 4.25 2.36 4.25 5.44v6.3zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z" />
                                </svg>
                            </a> */}
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-10 pt-6 border-t border-[#e7f3ee] dark:border-white/10 text-center">
                    <p className="text-sm text-[#4c9a78]">
                        © {new Date().getFullYear()} Tutor Match AE. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer